import { create } from "zustand";
import { persist } from "zustand/middleware";
import { SearchContext, SearchResult } from "@/types/search";

interface CommandPaletteState {
  isOpen: boolean;
  terminusRecentSearches: SearchResult[];
  foundershubRecentSearches: SearchResult[];
}

interface CommandPaletteActions {
  open: () => void;
  close: () => void;
  toggle: () => void;
  addToHistory: (result: SearchResult, context: SearchContext) => void;
  clearHistory: (context: SearchContext) => void;
  getRecentSearches: (context: SearchContext) => SearchResult[];
}

interface CommandPaletteStore
  extends CommandPaletteState,
    CommandPaletteActions {}

export const useCommandPaletteStore = create<CommandPaletteStore>()(
  persist(
    (set, get) => ({
      isOpen: false,
      terminusRecentSearches: [],
      foundershubRecentSearches: [],

      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
      toggle: () => set({ isOpen: !get().isOpen }),

      addToHistory: (result: SearchResult, context: SearchContext) => {
        if (context === SearchContext.FOUNDERSHUB) {
          const current = get().foundershubRecentSearches;
          const filtered = current.filter((r) => r.id !== result.id);
          set({ foundershubRecentSearches: [result, ...filtered].slice(0, 10) });
        } else {
          const current = get().terminusRecentSearches;
          const filtered = current.filter((r) => r.id !== result.id);
          set({ terminusRecentSearches: [result, ...filtered].slice(0, 10) });
        }
      },

      clearHistory: (context: SearchContext) => {
        if (context === SearchContext.FOUNDERSHUB) {
          set({ foundershubRecentSearches: [] });
        } else {
          set({ terminusRecentSearches: [] });
        }
      },

      getRecentSearches: (context: SearchContext) => {
        return context === SearchContext.FOUNDERSHUB
          ? get().foundershubRecentSearches
          : get().terminusRecentSearches;
      },
    }),
    {
      name: "command-palette-storage",
      partialize: (state) => ({
        terminusRecentSearches: state.terminusRecentSearches,
        foundershubRecentSearches: state.foundershubRecentSearches,
      }),
    }
  )
);
